// Shared constants/helpers for the participant food-diary UI.

// Meal slots — order matches the API enum (see api/food_diary.py MEALS).
export const MEALS = [
  { key: 'breakfast', label: 'Breakfast' },
  { key: 'lunch', label: 'Lunch' },
  { key: 'dinner', label: 'Dinner' },
  { key: 'snack', label: 'Snack' },
  { key: 'other', label: 'Other' }
]

export const MEAL_LABELS = MEALS.reduce((acc, m) => { acc[m.key] = m.label; return acc }, {})

// Marker colours for the calendar dots, one per meal slot.
export const MEAL_COLORS = {
  breakfast: '#f59e0b',
  lunch: '#10b981',
  dinner: '#6366f1',
  snack: '#ec4899',
  other: '#64748b'
}

// Which computed nutrients to surface, and how to label them. Keys match the
// myfood24 `values` codes stored on each entry's `nutrients`.
export const NUTRIENT_DISPLAY = [
  { key: 'KCALS', label: 'Energy', unit: 'kcal', dp: 0 },
  { key: 'PROT', label: 'Protein', unit: 'g', dp: 1 },
  { key: 'FAT', label: 'Fat', unit: 'g', dp: 1 },
  { key: 'CHO', label: 'Carbs', unit: 'g', dp: 1 }
]

// Format a Date as a participant-local 'YYYY-MM-DD' string (NOT UTC, so the
// diary day never shifts across timezones).
export function toDateStr (d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

// Parse a 'YYYY-MM-DD' string into a local Date (avoids the UTC-parsing shift of
// `new Date('2026-07-21')`).
export function parseDateStr (s) {
  const [y, m, d] = (s || '').split('-').map(Number)
  return new Date(y, (m || 1) - 1, d || 1)
}

export function formatDateLong (s) {
  return parseDateStr(s).toLocaleDateString('en-GB', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
  })
}

// Sum the `nutrients` maps across a set of entries.
export function sumNutrients (entries) {
  const totals = {}
  entries.forEach(e => {
    Object.entries(e.nutrients || {}).forEach(([k, v]) => {
      if (typeof v === 'number') totals[k] = (totals[k] || 0) + v
    })
  })
  return totals
}

// Human-readable portion summary for an entry, e.g. "1.5 × 30g serving, dry — 45g".
export function portionText (entry) {
  const q = entry.quantity ?? 1
  const p = entry.portion || {}
  const unit = p.unit === 'grams' ? 'g' : ` ${p.unit || ''}`.trimEnd()
  const base = p.size != null ? `${p.size}${unit}` : ''
  const desc = p.description ? ` ${p.description}` : ''
  const total = p.size != null ? ` — ${+(q * p.size).toFixed(1)}${unit}` : ''
  return `${q} × ${base}${desc}${total}`.trim()
}
